<template>
  <v-form>
    <v-layout>
      <v-app-bar app height="124" class="align-start elevation-1">
        <v-col cols="12" class="py-0">
          <v-row dense class="align-center flex-nowrap">
            <v-col cols="auto" class="d-flex d-lg-none pa-0">
              <!--Platzhalter für mobile Menu-->
              <div style="width: 50px"></div>
            </v-col>
            <v-col cols="auto">
              <v-toolbar-title>Termin erstellen</v-toolbar-title>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-btn outlined color="red lighten-1" @click="$router.go(-1)">
                <v-icon>mdi-cancel</v-icon>
                <span class="ml-1 d-none d-lg-flex">Abbrechen</span>
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn class="green lighten-1 grey--text text--lighten-4" @click="kundenSpeichern()" :disabled="validInsert">
                <v-icon>mdi-check</v-icon>
                <span class="ml-1 d-none d-lg-flex">Speichern</span>
              </v-btn>
            </v-col>
          </v-row>
          <v-row dense class="align-center">
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-select
                hide-details
                dense
                outlined
                required
                placeholder="Bearbeiter(*)"
                v-model="newDataset.Bearbeiter_ID"
                :items="Bearbeiter"
                item-text="Vorname"
                item-value="Bearbeiter_ID"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-col>
      </v-app-bar>

      <v-container fluid class="px-0 pt-0">
        <v-col cols="11" xl="8" lg="9" md="11" class="mx-auto px-0 pt-0">
          <!-- Termin- und Kundendaten -->
          <v-row dense class="align-center justify-center pb-5">
            <v-card tile outlined class="flex-grow-1">
              <v-col cols="12">
                <v-card-title class="px-2">
                  <v-row dense align="center">
                    <v-col cols="12">
                      <v-toolbar-title>
                        Termin / Kundendaten
                      </v-toolbar-title>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-divider inset></v-divider>
                <v-card-text class="px-2 subtitle-2">
                  <v-row dense align="center">
                    <v-col cols="12" xl="4" lg="5" md="6" sm="6">
                      <span class="font-weight-bold">Abteilung(*)</span>
                      <v-select
                        v-model="newDataset.Abteilung_ID"
                        :items="Abteilungen"
                        hide-details
                        dense
                        outlined
                        clearable
                        required
                        placeholder="Abteilung"
                        item-text="Abteilung_Kurzform"
                        item-value="Abteilung_ID"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" xl="4" lg="5" md="6" sm="6">
                      <span class="font-weight-bold">Terminkategorie(*)</span>
                      <v-select
                        v-model="newDataset.Terminkategorie_ID"
                        :items="Terminkategorien"
                        hide-details
                        dense
                        outlined
                        clearable
                        required
                        placeholder="Terminkategorie"
                        item-text="Terminkategorie"
                        item-value="Terminkategorie_ID"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-divider inset class="my-3"></v-divider>
                  <v-row dense align="center">
                    <v-spacer></v-spacer>
                    <v-col cols="12" xl="4" lg="4" md="4" sm="6">
                      <v-row dense v-if="newDataset.Datum">
                        <v-col cols="auto" class="mx-auto font-weight-bold">
                          <v-card shaped width="225">
                            <v-card-title :class="dateColor" style="height:64px;">
                              <v-row dense align="center" class="">
                                <v-col cols="auto">
                                  <span>{{ getDateMonthName(newDataset.Datum) }}</span>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="auto">
                                  <span>{{ new Date(newDataset.Datum).getFullYear() }}</span>
                                </v-col>
                              </v-row>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text style="height:150px;">
                              <v-row align="center" justify="center">
                                <v-col cols="12">
                                  <v-menu
                                    v-model="datepicker"
                                    :close-on-content-click="false"
                                    :nudge-right="30"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290"
                                    max-width="290"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn block outlined x-large v-bind="attrs" v-on="on">
                                        <span class="text--primary text-h1">{{
                                          new Date(newDataset.Datum).toLocaleDateString("de-DE", {
                                            day: "2-digit",
                                          }) + "."
                                        }}</span>
                                      </v-btn>
                                    </template>
                                    <v-date-picker
                                      v-model="newDataset.Datum"
                                      @input="datepicker = false"
                                      locale="de"
                                      first-day-of-week="1"
                                      full-width
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                              <v-row dense align="center" justify="center">
                                <v-col cols="auto"
                                  ><span class="text--primary text-h5">{{
                                    new Date(newDataset.Datum).toLocaleDateString("de-DE", {
                                      weekday: "long",
                                    })
                                  }}</span></v-col
                                >
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row dense v-else>
                        <v-col cols="auto" class="mx-auto font-weight-bold">
                          <v-card shaped width="225">
                            <v-card-title style="height:64px;">
                              <v-row dense align="center" justify="center">
                                <v-col cols="auto">Datum(*)</v-col>
                              </v-row>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text style="height:150px;">
                              <v-row dense align="center" justify="center" class="fill-height">
                                <v-col cols="12">
                                  <v-menu
                                    v-model="datepicker"
                                    :close-on-content-click="false"
                                    :nudge-right="30"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290"
                                    max-width="290"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn outlined block x-large color="green lighten-1" dark v-bind="attrs" v-on="on">
                                        <v-icon x-large>mdi-calendar-plus</v-icon>
                                      </v-btn>
                                    </template>
                                    <v-date-picker
                                      v-model="newDataset.Datum"
                                      @input="datepicker = false"
                                      locale="de"
                                      first-day-of-week="1"
                                      full-width
                                      show-adjacent-months
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="12" xl="7" lg="7" md="6" sm="6">
                      <v-row dense>
                        <v-col cols="12" xl="7" lg="9" md="12" sm="12">
                          <span class="font-weight-bold">Kundenname(*)</span>
                          <v-text-field v-model="newClient.Name" hide-details dense outlined clearable required placeholder="Kundenname">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="12" xl="7" lg="9" md="12" sm="12">
                          <span class="font-weight-bold">Telefon</span>
                          <v-text-field v-model="newClient.Telefon" hide-details dense outlined clearable required placeholder="Telefon">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="12" xl="7" lg="9" md="12" sm="12">
                          <span class="font-weight-bold">Email</span>
                          <v-text-field v-model="newClient.Email" hide-details dense outlined clearable required placeholder="Email"> </v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-card>
          </v-row>
          <!-- Terminartikel -->
          <v-row dense class="align-center justify-center pb-5">
            <v-card tile outlined class="flex-grow-1">
              <v-col cols="12">
                <v-card-title class="px-2">
                  <v-row dense align="center">
                    <v-col cols="auto">
                      <v-toolbar-title>
                        Artikel
                      </v-toolbar-title>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-card-title>
                <v-divider inset></v-divider>
                <v-card-text class="px-2 subtitle-2">
                  <v-row dense align="center">
                    <v-col cols="12" v-if="newArticle.length === 0">
                      <v-row dense align="center" justify="center">
                        <v-col cols="12" xl="auto" lg="auto" md="auto" sm="12">
                          <v-btn block outlined color="green lighten-2" @click="openSelectArticle">
                            <v-icon left>mdi-plus</v-icon>
                            <span>Artikel auswählen</span>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" v-for="item in newArticle" :key="item.Artikel_ID">
                      <v-card tile outlined>
                        <v-card-text class="subtitle-2 text--primary">
                          <v-row dense align="center">
                            <v-col cols="auto">
                              <div class="font-weight-bold text-h5">
                                <span>{{ item.Aktion + " von " + item.Artikelname }}</span>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row dense align="center">
                            <v-col cols="9" md="4" sm="8" xl="4" lg="4">
                              <span class="font-weight-bold">Artikelnummer: </span>
                              <span>{{ item.Artikelnummer }}</span>
                            </v-col>
                            <v-col cols="8" md="4" sm="8" xl="4" lg="4">
                              <span class="font-weight-bold">Größe: </span>
                              <span>{{ item.Größe }}</span>
                            </v-col>
                            <v-col cols="8" md="4" sm="8" xl="4" lg="4">
                              <span class="font-weight-bold">Preis: </span>
                              <span>{{ item.Preis + " €" }}</span>
                            </v-col>
                            <v-col cols="6" md="6" sm="6" xl="auto" lg="auto">
                              <v-menu offset-y :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn icon outlined v-bind="attrs" v-on="on">
                                    <v-icon>mdi-information-variant</v-icon>
                                  </v-btn>
                                </template>
                                <v-card width="575">
                                  <v-card-title><span>Artikelinformationen:</span> </v-card-title>
                                  <v-divider></v-divider>
                                  <v-card-text class="text--primary">
                                    <v-row dense align="center" justify="center">
                                      <v-col cols="12" v-for="item in newArticle" :key="item.Artikel_ID">
                                        <v-row dense>
                                          <v-col cols="5" class="font-weight-bold">
                                            Artikelname
                                          </v-col>
                                          <v-col cols="7">
                                            <span v-if="item.Artikelname">
                                              {{ item.Artikelname }}
                                            </span>
                                          </v-col>
                                        </v-row>

                                        <v-row dense>
                                          <v-col cols="5" class="font-weight-bold">
                                            Farbe(n)
                                          </v-col>
                                          <v-col cols="7">
                                            <span v-if="item.Farben">
                                              {{ item.Farben }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                        <v-row dense>
                                          <v-col cols="5" class="font-weight-bold">
                                            Stoff(e)
                                          </v-col>
                                          <v-col cols="7">
                                            <span v-if="item.Stoffe">
                                              {{ item.Stoffe }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                        <v-row dense>
                                          <v-col cols="5" class="font-weight-bold">
                                            Schnitt
                                          </v-col>
                                          <v-col cols="7">
                                            <span v-if="item.Schnitt">
                                              {{ item.Schnitt }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                        <v-row dense>
                                          <v-col cols="5" class="font-weight-bold">
                                            Besonderheiten
                                          </v-col>
                                          <v-col cols="7">
                                            <span v-if="item.Besonderheiten">
                                              {{ item.Besonderheiten }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                        <v-row dense>
                                          <v-col cols="5" class="font-weight-bold">
                                            VK brutto
                                          </v-col>
                                          <v-col cols="7">
                                            <span v-if="item.VK_brutto">
                                              {{ item.VK_brutto + " €" }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                        <v-row dense>
                                          <v-col cols="5" class="font-weight-bold">
                                            Leihpreis
                                          </v-col>
                                          <v-col cols="7">
                                            <span v-if="item.Leihpreis">
                                              {{ item.Leihpreis + " €" }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-menu>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="auto" v-if="newArticle.length > 0">
                              <v-btn text outlined rounded color="red lighten-2" @click="removeArticle(item.Artikel_ID)"
                                ><v-icon>mdi-close</v-icon></v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-card>
          </v-row>
          <!-- Terminaccessoires -->
          <v-row dense class="align-center justify-center pb-5">
            <v-card tile outlined class="flex-grow-1">
              <v-col cols="12">
                <v-card-title class="px-2">
                  <v-row dense align="center">
                    <v-col cols="auto">
                      <v-toolbar-title>
                        Accessoires
                      </v-toolbar-title>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-card-title>
                <v-divider inset></v-divider>
                <v-card-text class="px-2 subtitle-2">
                  <v-row dense align="center">
                    <v-col cols="12" v-for="item in newAccessoires" :key="item.Artikel_ID">
                      <v-card tile outlined>
                        <v-card-text class="subtitle-2 text--primary">
                          <v-row dense align="center">
                            <v-col cols="auto">
                              <div class="font-weight-bold text-h5">
                                <span>{{ item.Aktion + " von " + item.Artikelname }}</span>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row dense align="center">
                            <v-col cols="9" md="4" sm="8" xl="4" lg="4">
                              <span class="font-weight-bold">Artikelnummer: </span>
                              <span>{{ item.Artikelnummer }}</span>
                            </v-col>
                            <v-col cols="8" md="4" sm="8" xl="4" lg="4">
                              <span class="font-weight-bold">Größe: </span>
                              <span>{{ item.Größe }}</span>
                            </v-col>
                            <v-col cols="8" md="4" sm="8" xl="4" lg="4">
                              <span class="font-weight-bold">Preis: </span>
                              <span>{{ item.Preis + " €" }}</span>
                            </v-col>
                            <v-col cols="6" md="6" sm="6" xl="auto" lg="auto">
                              <v-menu offset-y :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn icon outlined v-bind="attrs" v-on="on">
                                    <v-icon>mdi-information-variant</v-icon>
                                  </v-btn>
                                </template>
                                <v-card width="575">
                                  <v-card-title><span>Artikelinformationen:</span> </v-card-title>
                                  <v-divider></v-divider>
                                  <v-card-text class="text--primary">
                                    <v-row dense align="center" justify="center">
                                      <v-col cols="12">
                                        <v-row dense>
                                          <v-col cols="5" class="font-weight-bold">
                                            Artikelname
                                          </v-col>
                                          <v-col cols="7">
                                            <span v-if="item.Artikelname">
                                              {{ item.Artikelname }}
                                            </span>
                                          </v-col>
                                        </v-row>

                                        <v-row dense>
                                          <v-col cols="5" class="font-weight-bold">
                                            Farbe(n)
                                          </v-col>
                                          <v-col cols="7">
                                            <span v-if="item.Farben">
                                              {{ item.Farben }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                        <v-row dense>
                                          <v-col cols="5" class="font-weight-bold">
                                            Stoff(e)
                                          </v-col>
                                          <v-col cols="7">
                                            <span v-if="item.Stoffe">
                                              {{ item.Stoffe }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                        <v-row dense>
                                          <v-col cols="5" class="font-weight-bold">
                                            Schnitt
                                          </v-col>
                                          <v-col cols="7">
                                            <span v-if="item.Schnitt">
                                              {{ item.Schnitt }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                        <v-row dense>
                                          <v-col cols="5" class="font-weight-bold">
                                            Besonderheiten
                                          </v-col>
                                          <v-col cols="7">
                                            <span v-if="item.Besonderheiten">
                                              {{ item.Besonderheiten }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                        <v-row dense>
                                          <v-col cols="5" class="font-weight-bold">
                                            VK brutto
                                          </v-col>
                                          <v-col cols="7">
                                            <span v-if="item.VK_brutto">
                                              {{ item.VK_brutto + " €" }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                        <v-row dense>
                                          <v-col cols="5" class="font-weight-bold">
                                            Leihpreis
                                          </v-col>
                                          <v-col cols="7">
                                            <span v-if="item.Leihpreis">
                                              {{ item.Leihpreis + " €" }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-menu>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="auto" v-if="newAccessoires.length > 0">
                              <v-btn text outlined rounded color="red lighten-2" @click="removeAccessoire(item.Artikel_ID)"
                                ><v-icon>mdi-close</v-icon></v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12">
                      <v-row dense align="center" justify="center">
                        <v-col cols="12" xl="auto" lg="auto" md="auto" sm="12">
                          <v-btn block outlined color="green lighten-2" @click="openSelectAccessoire">
                            <v-icon left>mdi-plus</v-icon>
                            <span>Accessoire auswählen</span>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-card>
          </v-row>
          <!-- Terminnotizen -->
          <v-row dense class="align-center justify-center">
            <v-card tile outlined class="flex-grow-1">
              <v-col cols="12">
                <v-card-title class="px-2">
                  <v-row dense align="center">
                    <v-col cols="auto">
                      <v-toolbar-title>
                        Anmerkungen / Notizen
                      </v-toolbar-title>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                      <v-btn outlined color="green lighten-2" @click="openNote"
                        ><v-icon left>mdi-plus</v-icon><span class="d-none d-lg-flex">neue&nbsp;</span> <span>Notiz</span></v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-divider inset></v-divider>
                <v-card-text class="px-2 subtitle-2">
                  <v-row dense align="center">
                    <v-col cols="12" v-if="newNotes.length === 0">
                      <v-card tile outlined>
                        <v-card-text class="text--primary">
                          keine Anmerkungen / Notizen vorhanden
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" v-for="item in newNotes" :key="item.temp_id">
                      <v-card tile outlined>
                        <v-card-text>
                          <v-row dense align="center">
                            <v-col cols="auto" class="flex-grow-1 text--primary subtitle-2">
                              {{ item.Notiz }}
                            </v-col>
                            <v-col cols="auto" v-if="newNotes.length > 0">
                              <v-btn text outlined rounded color="red lighten-2" @click="removeNote(item.temp_id)"><v-icon>mdi-close</v-icon></v-btn>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-card>
          </v-row>
        </v-col>
      </v-container>
    </v-layout>

    <SelectArticle ref="SelectArticle" @addArticle="addArticle" :initialDataset="tempArticle" :usedArticles="selectedIDs" />
    <SelectAccessoire ref="SelectAccessoire" @addAccessoire="addAccessoire" :initialDataset="tempAccessoire" :usedArticles="selectedIDs" />
    <Note ref="Note" @addNote="addNote" />

    <LeavePathWrapper ref="leavePath">
      <LeavePathDialog />
    </LeavePathWrapper>
  </v-form>
</template>

<script>
import Note from "./dialogs/Note.vue";
import SelectArticle from "./dialogs/SelectArticle.vue";
import SelectAccessoire from "./dialogs/SelectAccessoire.vue";

import LeavePathWrapper from "../../../components/dialogs/LeavePathWrapper.vue";
import LeavePathDialog from "../../../components/dialogs/LeavePathDialog.vue";

export default {
  components: {
    Note,
    SelectArticle,
    SelectAccessoire,
    LeavePathWrapper,
    LeavePathDialog,
  },

  mounted() {
    this.initialize();
  },

  beforeRouteLeave(to, from, next) {
    if (this.saved === true || this.checkDifferences === false) {
      next();
    } else if (this.saved === false) {
      this.$refs.leavePath.open().then((result) => {
        if (result === true) {
          next();
        } else if (result === false) {
          next(false);
        }
      });
    }
  },

  data: () => ({
    Abteilungen: [],
    Terminkategorien: [],
    Artikel: [],
    Artikelnamen: [],
    Bearbeiter: [],
    defaultDataset: {
      Abteilung_ID: null,
      Terminkategorie_ID: null,
      Datum: null,
      Kunden_ID: null,
      Bearbeiter_ID: null,
    },
    defaultClient: {
      Name: null,
      Telefon: null,
      Email: null,
    },
    newDataset: {},
    newClient: {},
    newArticle: [],
    tempArticle: {},
    newAccessoires: [],
    tempAccessoire: {},
    newNotes: [],
    selectedArtikelname: "",
    selectedArtikel: {},
    selectedAccessoires: [{ selectedAccessoire: "" }],
    saved: false,
    datepicker: false,
    date: null,
    artoracc: "",
    selectedArticleAndAccessoires: [],
  }),

  computed: {
    checkCurrentUser() {
      const user = localStorage.getItem("user");

      if (user === "Aline" || user === "andre") {
        return true;
      } else return false;
    },

    checkDifferences() {
      if (
        this.newDataset.Abteilung_ID === this.defaultDataset.Abteilung_ID &&
        this.newDataset.Terminkategorie_ID === this.defaultDataset.Terminkategorie_ID &&
        this.newDataset.Datum === this.defaultDataset.Datum &&
        this.newClient.Name === this.defaultClient.Name &&
        this.newClient.Telefon === this.defaultClient.Telefon &&
        this.newClient.Email === this.defaultClient.Email &&
        this.newArticle.length === 0 &&
        this.newAccessoires.length === 0 &&
        this.newNotes.length === 0
      ) {
        return false;
      } else return true;
    },

    validInsert() {
      if (
        !this.newDataset.Bearbeiter_ID ||
        !this.newClient.Name ||
        !this.newDataset.Terminkategorie_ID ||
        !this.newDataset.Datum ||
        this.newArticle.length === 0
      ) {
        return true;
      } else return false;
    },

    dateColor() {
      if (this.newDataset.Terminkategorie_ID === 1) {
        return "Leih";
      } else if (this.newDataset.Terminkategorie_ID === 2) {
        return "Kauf";
      } else if (this.newDataset.Terminkategorie_ID === 3) {
        return "Bestand";
      } else return "";
    },

    selectedArticleID() {
      if (this.newArticle.length > 0) {
        return this.newArticle.map((it) => it.Artikel_ID);
      } else return [];
    },

    selectedAccessoireIDs() {
      if (this.newAccessoires.length > 0) {
        return this.newAccessoires.map((it) => it.Artikel_ID);
      } else return [];
    },

    selectedIDs() {
      return this.selectedArticleID.concat(this.selectedAccessoireIDs);
    },
  },

  methods: {
    async initialize() {
      const response = await fetch(`/api/${this.$route.meta.request}/dataset/createappointment`);
      const json = await response.json();

      for (let [key, value] of Object.entries(json)) {
        this[key] = value;
      }

      this.newDataset = Object.assign({}, this.defaultDataset);
      this.newClient = Object.assign({}, this.defaultClient);
      this.newNote = Object.assign({}, this.defaultNote);
    },

    getDateMonthName(date) {
      const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

      const d = new Date(date);
      return monthNames[d.getMonth()];
    },

    openSelectArticle() {
      this.$refs.SelectArticle.open();
    },

    addArticle(article) {
      this.newArticle.push(article);
    },

    removeArticle(id) {
      var index = this.newArticle
        .map((x) => {
          return x.Artikel_ID;
        })
        .indexOf(id);

      this.newArticle.splice(index, 1);
    },

    openSelectAccessoire() {
      this.$refs.SelectAccessoire.open();
    },

    addAccessoire(accessoire) {
      this.newAccessoires.push(accessoire);
    },

    removeAccessoire(id) {
      var index = this.newAccessoires
        .map((x) => {
          return x.Artikel_ID;
        })
        .indexOf(id);

      this.newAccessoires.splice(index, 1);
    },

    openNote() {
      const noteid = this.newNotes.length;
      this.$refs.Note.open(noteid);
    },

    addNote(note) {
      this.newNotes.push(note);
    },

    removeNote(id) {
      var index = this.newNotes
        .map((x) => {
          return x.temp_id;
        })
        .indexOf(id);

      this.newNotes.splice(index, 1);
    },

    async kundenSpeichern() {
      const clientToInsert = {};

      if (Object.keys(clientToInsert).length === 0) {
        Object.assign(clientToInsert, {
          Name: this.newClient.Name,
          Telefon: this.newClient.Telefon,
          Email: this.newClient.Email,
        });
      }

      const saveresponse = await fetch(`/api/${this.$route.meta.request}/client/insertclient`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(clientToInsert),
      });
      const jsonclient = await saveresponse.json();
      const newclientid = jsonclient.lastInsertRowid;

      this.terminSpeichern(newclientid);
    },

    async terminSpeichern(clientid) {
      const datasetToInsert = {};

      if (Object.keys(datasetToInsert).length === 0) {
        Object.assign(datasetToInsert, {
          Abteilung_ID: this.newDataset.Abteilung_ID,
          Terminkategorie_ID: this.newDataset.Terminkategorie_ID,
          Kunden_ID: clientid,
          Datum: this.newDataset.Datum,
          Bearbeiter_ID: this.newDataset.Bearbeiter_ID,
          ist_abgesagt: 0,
        });
      }

      const saveresponse = await fetch(`/api/${this.$route.meta.request}/dataset/insertappointment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(datasetToInsert),
      });

      const jsonappointment = await saveresponse.json();
      const newappointmentid = jsonappointment.lastInsertRowid;

      const datasetEventToInsert = {};

      if (Object.keys(datasetEventToInsert).length === 0) {
        Object.assign(datasetEventToInsert, {
          Vorgang_ID: 1,
          Termin_ID: newappointmentid,
          Bearbeiter_ID: this.newDataset.Bearbeiter_ID,
        });
      }

      await fetch(`/api/${this.$route.meta.request}/event/createevent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(datasetEventToInsert),
      });

      this.terminArtikelSpeichern(newappointmentid, clientid, datasetToInsert.Bearbeiter_ID);
      this.terminAccessoiresSpeichern(newappointmentid, clientid, datasetToInsert.Bearbeiter_ID);
      this.notizenSpeichern(newappointmentid);

      this.$root.actionSnackbar.show({
        dataset: "Termin",
        action: "erstellt",
      });
      this.saved = true;
      this.$router.replace({
        path: `/wws/${this.$route.meta.request}/dataset/show/${newappointmentid}`,
      });
    },

    async terminArtikelSpeichern(newappointmentid, newclientid, bearbeiterid) {
      const multipleArticlesAdd = this.newArticle;
      const request = this.$route.meta.request;

      multipleArticlesAdd.forEach(async function(article) {
        const articleToAdd = {};

        if (Object.keys(articleToAdd).length === 0) {
          Object.assign(articleToAdd, {
            Termin_ID: newappointmentid,
            Artikel_ID: article.Artikel_ID,
            Artikelname_ID: article.Artikelname_ID,
            Preis: article.Preis,
            Bearbeiter_ID: bearbeiterid,
          });
        }

        if (article.neu === true) {
          // wenn es ein neuer Artikel ist

          if (article.Aktion === "Verkauf") {
            // wenn der Artikel verkauft wird
            // Terminartikelposten speichern
            // Artikelevent "Verkauft" hinzufügen
            await fetch(`/api/${request}/article/insertappointmentarticlesold`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(articleToAdd),
            });
            await fetch(`/api/${request}/article/addevent/verkauft`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(articleToAdd),
            });

            if (article.Status_ID === 2) {
              // wenn der Artikel verfügbar (d.h. Bestand ist größer 0)

              if (article.Bestellstatus_ID === 1) {
                // wenn der Artikel nicht bestellbar ist
                // Bestand um 1 reduzieren

                await fetch(`/api/${request}/article/stockamount/reduzieren`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(articleToAdd),
                });

                if (article.Bestand - 1 === 0) {
                  // wenn der Bestand durch den Verkauf 0 erreicht
                  // Artikel als verkauft markieren
                  await fetch(`/api/${request}/article/setstatus/verkauft`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(articleToAdd),
                  });
                  if (article.Artikelname_ID !== null) {
                    await fetch(`/api/database/articles/dataset/name/available`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(articleToAdd),
                    });
                  }
                }
              } else if (article.Bestellstatus_ID === 2) {
                // wenn der Artikel bestellbar ist
                // Bestand um 1 reduzieren
                await fetch(`/api/${request}/article/stockamount/reduzieren`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(articleToAdd),
                });

                if (article.ist_bestandsgeführt === 0) {
                  // wenn der Artikel nicht bestandsgeführt ist

                  if (article.Bestand - 1 === 0) {
                    // wenn der Bestand durch den Verkauf 0 erreicht
                    // Artikel als verkauft markieren
                    await fetch(`/api/${request}/article/setstatus/verkauft`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(articleToAdd),
                    });
                    if (article.Artikelname_ID !== null) {
                      await fetch(`/api/database/articles/dataset/name/available`, {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify(articleToAdd),
                      });
                    }
                  }
                } else if (article.ist_bestandsgeführt === 1) {
                  // wenn der Artikel bestandsgeführt ist

                  if (article.Bestand - 1 < article.Mindestbestand) {
                    // wenn der Bestand den Mindestbestand durch den Verkauf unterschreitet
                    // automatisch Bestellvormerkung erstellen (nicht verpflichtend)
                    // Artikel Bestellstatus als "vorgemerkt" markieren
                    await fetch(`/api/${request}/article/addorderproposal`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(articleToAdd),
                    });

                    await fetch(`/api/${request}/article/setorderstatus/vorgemerkt`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(articleToAdd),
                    });
                  }
                  if (article.Bestand - 1 === 0) {
                    // wenn der Bestand durch den Verkauf 0 erreicht
                    // Artikel als verkauft markieren
                    await fetch(`/api/${request}/article/setstatus/verkauft`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(articleToAdd),
                    });
                  }
                }
              } else if (article.Bestellstatus_ID === 3) {
                // wenn der Artikel bereits zum Bestellen vorgemerkt ist
                // Bestand um 1 reduzieren
                await fetch(`/api/${request}/article/stockamount/reduzieren`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(articleToAdd),
                });

                if (article.ist_bestandsgeführt === 0) {
                  // wenn der Artikel nicht bestandsgeführt ist

                  if (article.Bestand - 1 === 0) {
                    // wenn der Bestand durch den Verkauf 0 erreicht
                    // Artikel als verkauft markieren
                    await fetch(`/api/${request}/article/setstatus/verkauft`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(articleToAdd),
                    });
                  }
                } else if (article.ist_bestandsgeführt === 1) {
                  // wenn der Artikel bestandsgeführt ist

                  if (article.Bestand - 1 < article.Mindestbestand) {
                    // wenn der Bestand den Mindestbestand durch den Verkauf unterschreitet
                    // automatisch die zu bestellende Menge in der bestehenden Bestellvormerkung um 1 erhöhen
                    await fetch(`/api/${request}/article/updateorderproposal/zubestellendemenge/erhoehen`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(articleToAdd),
                    });
                  }
                  if (article.Bestand - 1 === 0) {
                    // wenn der Bestand durch den Verkauf 0 erreicht
                    // Artikel als verkauft markieren
                    await fetch(`/api/${request}/article/setstatus/verkauft`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(articleToAdd),
                    });
                  }
                }
              }
            } else if (article.Status_ID === 3) {
              // wenn der Artikel bereits verkauft ist (d.h. Bestand ist bereits 0 und kann nicht weiter reduziert werden)

              if (article.Bestellstatus_ID === 1) {
                // wenn der Artikel nicht bestellbar ist
                // dann darf der Artikel gar nicht erst ausgewählt werden
              } else if (article.Bestellstatus_ID === 2) {
                // wenn der Artikel bestellbar ist
                // automatisch Bestellvormerkung erstellen mit zu bestellender Menge 1 und diese verpflichtend machen
                // Artikel Bestellstatus als "vorgemerkt" markieren
                await fetch(`/api/${request}/article/addorderproposal`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(articleToAdd),
                });
                await fetch(`/api/${request}/article/setorderstatus/vorgemerkt`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(articleToAdd),
                });
              } else if (article.Bestellstatus_ID === 3) {
                // wenn der Artikel bereits zum Bestellen vorgemerkt ist
                // automatisch die zu bestellende Menge in der bestehenden Bestellvormerkung um 1 erhöhen
                await fetch(`/api/${request}/article/updateorderproposal/zubestellendemenge/erhoehen`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(articleToAdd),
                });
              }
            }
          } else if (article.Aktion === "Verleih") {
            await fetch(`/api/${request}/article/insertappointmentarticlerent`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(articleToAdd),
            });
            await fetch(`/api/${request}/article/amountrent/erhoehen`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(articleToAdd),
            });
            await fetch(`/api/${request}/article/addevent/verliehen`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(articleToAdd),
            });
          }
        }
      });
    },

    async terminAccessoiresSpeichern(newappointmentid, newclientid, bearbeiterid) {
      const multipleArticlesAdd = this.newAccessoires;
      const request = this.$route.meta.request;

      multipleArticlesAdd.forEach(async function(article) {
        const articleToAdd = {};

        if (Object.keys(articleToAdd).length === 0) {
          Object.assign(articleToAdd, {
            Termin_ID: newappointmentid,
            Artikel_ID: article.Artikel_ID,
            Artikelname_ID: article.Artikelname_ID,
            Preis: article.Preis,
            Bearbeiter_ID: bearbeiterid,
          });
        }

        if (article.neu === true) {
          // wenn es ein neuer Artikel ist

          if (article.Aktion === "Verkauf") {
            // wenn der Artikel verkauft wird
            // Terminartikelposten speichern
            // Artikelevent "Verkauft" hinzufügen
            await fetch(`/api/${request}/article/insertappointmentaccessoiresold`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(articleToAdd),
            });
            await fetch(`/api/${request}/article/addevent/verkauft`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(articleToAdd),
            });

            if (article.Status_ID === 2) {
              // wenn der Artikel verfügbar (d.h. Bestand ist größer 0)

              if (article.Bestellstatus_ID === 1) {
                // wenn der Artikel nicht bestellbar ist
                // Bestand um 1 reduzieren

                await fetch(`/api/${request}/article/stockamount/reduzieren`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(articleToAdd),
                });

                if (article.Bestand - 1 === 0) {
                  // wenn der Bestand durch den Verkauf 0 erreicht
                  // Artikel als verkauft markieren
                  await fetch(`/api/${request}/article/setstatus/verkauft`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(articleToAdd),
                  });
                  if (article.Artikelname_ID !== null) {
                    await fetch(`/api/database/articles/dataset/name/available`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(articleToAdd),
                    });
                  }
                }
              } else if (article.Bestellstatus_ID === 2) {
                // wenn der Artikel bestellbar ist
                // Bestand um 1 reduzieren
                await fetch(`/api/${request}/article/stockamount/reduzieren`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(articleToAdd),
                });

                if (article.ist_bestandsgeführt === 0) {
                  // wenn der Artikel nicht bestandsgeführt ist

                  if (article.Bestand - 1 === 0) {
                    // wenn der Bestand durch den Verkauf 0 erreicht
                    // Artikel als verkauft markieren
                    await fetch(`/api/${request}/article/setstatus/verkauft`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(articleToAdd),
                    });
                    if (article.Artikelname_ID !== null) {
                      await fetch(`/api/database/articles/dataset/name/available`, {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify(articleToAdd),
                      });
                    }
                  }
                } else if (article.ist_bestandsgeführt === 1) {
                  // wenn der Artikel bestandsgeführt ist

                  if (article.Bestand - 1 < article.Mindestbestand) {
                    // wenn der Bestand den Mindestbestand durch den Verkauf unterschreitet
                    // automatisch Bestellvormerkung erstellen (nicht verpflichtend)
                    // Artikel Bestellstatus als "vorgemerkt" markieren
                    await fetch(`/api/${request}/article/addorderproposal`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(articleToAdd),
                    });

                    await fetch(`/api/${request}/article/setorderstatus/vorgemerkt`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(articleToAdd),
                    });
                  }
                  if (article.Bestand - 1 === 0) {
                    // wenn der Bestand durch den Verkauf 0 erreicht
                    // Artikel als verkauft markieren
                    await fetch(`/api/${request}/article/setstatus/verkauft`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(articleToAdd),
                    });
                  }
                }
              } else if (article.Bestellstatus_ID === 3) {
                // wenn der Artikel bereits zum Bestellen vorgemerkt ist
                // Bestand um 1 reduzieren
                await fetch(`/api/${request}/article/stockamount/reduzieren`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(articleToAdd),
                });

                if (article.ist_bestandsgeführt === 0) {
                  // wenn der Artikel nicht bestandsgeführt ist

                  if (article.Bestand - 1 === 0) {
                    // wenn der Bestand durch den Verkauf 0 erreicht
                    // Artikel als verkauft markieren
                    await fetch(`/api/${request}/article/setstatus/verkauft`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(articleToAdd),
                    });
                  }
                } else if (article.ist_bestandsgeführt === 1) {
                  // wenn der Artikel bestandsgeführt ist

                  if (article.Bestand - 1 < article.Mindestbestand) {
                    // wenn der Bestand den Mindestbestand durch den Verkauf unterschreitet
                    // automatisch die zu bestellende Menge in der bestehenden Bestellvormerkung um 1 erhöhen
                    await fetch(`/api/${request}/article/updateorderproposal/zubestellendemenge/erhoehen`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(articleToAdd),
                    });
                  }
                  if (article.Bestand - 1 === 0) {
                    // wenn der Bestand durch den Verkauf 0 erreicht
                    // Artikel als verkauft markieren
                    await fetch(`/api/${request}/article/setstatus/verkauft`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(articleToAdd),
                    });
                  }
                }
              }
            } else if (article.Status_ID === 3) {
              // wenn der Artikel bereits verkauft ist (d.h. Bestand ist bereits 0 und kann nicht weiter reduziert werden)

              if (article.Bestellstatus_ID === 1) {
                // wenn der Artikel nicht bestellbar ist
                // dann darf der Artikel gar nicht erst ausgewählt werden
              } else if (article.Bestellstatus_ID === 2) {
                // wenn der Artikel bestellbar ist
                // automatisch Bestellvormerkung erstellen mit zu bestellender Menge 1 und diese verpflichtend machen
                // Artikel Bestellstatus als "vorgemerkt" markieren
                await fetch(`/api/${request}/article/addorderproposal`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(articleToAdd),
                });
                await fetch(`/api/${request}/article/setorderstatus/vorgemerkt`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(articleToAdd),
                });
              } else if (article.Bestellstatus_ID === 3) {
                // wenn der Artikel bereits zum Bestellen vorgemerkt ist
                // automatisch die zu bestellende Menge in der bestehenden Bestellvormerkung um 1 erhöhen
                await fetch(`/api/${request}/article/updateorderproposal/zubestellendemenge/erhoehen`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(articleToAdd),
                });
              }
            }
          } else if (article.Aktion === "Verleih") {
            await fetch(`/api/${request}/article/insertappointmentaccessoirerent`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(articleToAdd),
            });
            await fetch(`/api/${request}/article/amountrent/erhoehen`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(articleToAdd),
            });
            await fetch(`/api/${request}/article/addevent/verliehen`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(articleToAdd),
            });
          }
        }
      });
    },

    async notizenSpeichern(newappointmentid) {
      const multipleNotesAdd = this.newNotes;
      const request = this.$route.meta.request;

      multipleNotesAdd.forEach(async function(note) {
        const noteToAdd = {};

        if (Object.keys(noteToAdd).length === 0) {
          Object.assign(noteToAdd, {
            Termin_ID: newappointmentid,
            Notiz: note.Notiz,
            neu: note.neu,
          });

          if (noteToAdd.neu === true) {
            await fetch(`/api/${request}/note/insertnote`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(noteToAdd),
            });
          }
        }
      });

      setTimeout(() => {
        this.$root.mainmenu.reinitialize();
      }, 500);
    },
  },
};
</script>

<style>
.Leih {
  background: #53ff5c !important;
}

.Kauf {
  background: #fcff51 !important;
}

.Bestand {
  background: #d52bff !important;
}
</style>
